<template>
  <div class="ksm-sidebar__wrapper">
    <div class="ksm-sidebar__container">
      <template v-for="(accor,i) in list">
        <div
          class="ksm-accordion__header"
          :key="'t'+i"
          :style="i==0?'border-top-color:transparent':''"
        >
          <div
            style="width:22px; height:100%; padding:3px"
            @click="clickAccordion(accor)"
            v-html="$_getIcon(openedAccordionId===i?'arrow-down.svg':'arrow-right.svg')"
          ></div>
          <div
            class="ksm-flex-1 ksm-flex"
            style="align-items: center"
            @click="clickAccordion(accor)"
          >{{accor.label}}</div>
          <div v-if="!hiddenToolbar" class="ksm-accordion__header-tool" style="width:40px">
            <div
              class="ksm-icon-circle"
              :style="accor.checked? 'background-color:'+accor.color:''"
              @click="clickColorCBX(accor)"
            ></div>
          </div>
        </div>
        <div
          class="ksm-accordion__body"
          :class="accor.isExpand?'ksm-accordion__expand':'ksm-accordion__collapse' "
          :key="'b'+i"
        >
          <div class="ksm-orteundwege__accordion-container">
            <!-- infotext -->
            <template v-if="accor.isInfoText">
              <div class="ksm-hyphens" lang="de" v-html="infoText"></div>
            </template>

            <!-- holland dada merzabende -->
            <template v-else-if="accor.id!=='merzgebiete'">
              <table style="width:100%">
                <tr
                  v-for="(infoItem, pi) of accor.infoItems"
                  :key="'infoItem'+pi"
                  @click="clickInfoItem(infoItem)"
                  class="ksm-orteundwege__accordion-row"
                  :class="infoItem===activeInfoItem?'__'+accor.id+'-active':'__'+accor.id"
                >
                  <template v-if="['holland','merzabende'].indexOf(accor.id)>-1">
                    <td>{{infoItem.row._datvon}}{{infoItem.row._datbis?(' &ndash; '+infoItem.row._datbis):''}}</td>
                    <td
                      style="min-width:83pt"
                    >{{infoItem.row.stadtname?infoItem.row.stadtname:infoItem.row.ortsname}}</td>
                    <td>{{!infoItem.row.stadtname?'':infoItem.row.ortsname}}</td>
                    <td>{{infoItem.row.short_113_html}}</td>
                  </template>
                  <template v-if="['ausstellung'].indexOf(accor.id)>-1">
                    <td
                      style="max-width:50pt"
                    >{{infoItem.row._datvon}}{{infoItem.row._datbis?(' &ndash; '+infoItem.row._datbis):''}}</td>
                    <td>{{infoItem.row.titel}}</td>
                  </template>
                  <template
                    v-if="['veranstaltung','veröffentlichung','institutionen'].indexOf(accor.id)>-1"
                  >
                    <td>{{infoItem.row._datvon}}{{infoItem.row._datbis?(' &ndash; '+infoItem.row._datbis):''}}</td>
                    <td>{{infoItem.row.stadtname}}</td>
                    <td>{{infoItem.row.ortsname}}</td>
                    <td>{{infoItem.row.titel}}</td>
                  </template>
                </tr>
              </table>

              <!-- <div
                v-for="(infoItem, pi) of accor.infoItems"
                :key="'infoItem'+pi"
                @click="clickInfoItem(infoItem)"
              >
         
                <div
                  class="ksm-orteundwege__accordion-row"
                  :class="infoItem===activeInfoItem?'__'+accor.id+'-active':'__'+accor.id"
                >
                  <div
                    class="ksm-flex-00auto"
                    style="margin-right:10px; width:auto"
                  >{{infoItem.row._datvon}}{{infoItem.row._datbis?(' &ndash; '+infoItem.row._datbis):''}}</div>
                  <div>{{infoItem.row.stadtname}} {{infoItem.row.ortsname}} {{infoItem.row.short_113_html}}</div>
                  <div v-if="accor.showTitle" style="margin-left:10px">{{infoItem.row.titel}}</div>
              </div>-->
              <!-- </div> -->
            </template>

            <!-- merzgebiete -->
            <template v-else-if="accor.id==='merzgebiete'">
              <div v-for="(mg,mi) of accor.merzgebiete" :key="'mg'+mi">
                <div class="ksm-flex-y-center">
                  <div
                    class="ksm-orteundwege__merzgebiete-icon"
                    :style="mg.checked?'background-color:'+mg.color:''"
                    @click="mg.checked=!mg.checked"
                  ></div>
                  {{mg.name}}
                </div>
              </div>
            </template>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    list: Array,
    hiddenToolbar: Boolean
  },

  data() {
    return {
      openedAccordionId: 0
    };
  },

  methods: {
    clickAccordion(accor) {
      if (accor.isInfoText) {
        return;
      }
      this.$store.commit("orteundwege/expandAccor", accor);
    },

    clickColorCBX(accor) {
      accor.checked = !accor.checked;
      this.$store.commit("orteundwege/updatePiechartIcon");
    },

    clickInfoItem(infoItem) {
      this.$store.commit("orteundwege/activeInfoItem", infoItem);
    }
  },

  //
  mounted() {
    const vue = this;
    this.$store.state.eventBus.$on("ortundwege-accor-scroll", function(item) {
      setTimeout(function() {
        const elem = vue.$el.querySelector(".__" + item.accor.id + "-active");
        if (elem) {
          elem.scrollIntoView({ block: "start", behavior: "smooth" });
        }
      }, 300);
    });
  },

  //
  computed: {
    lemmaID() {
      return this.$route.query.lemmaID;
    },
    activeInfoItem() {
      return this.$store.getters["orteundwege/activeInfoItem"];
    },
    infoText() {
      if (!this.sidebarRightList) {
        return "";
      }

      let infoText = "";
      const accor = this.sidebarRightList.find(accor => accor.isExpand);
      if (accor.textDoc) {
        infoText = accor.textDoc._source["113_html"];
        infoText = this.$_getNewHtmlElement(
          infoText,
          null,
          accor.textDoc,
          true
        );
        infoText = infoText.innerHTML;
      }
      return infoText;
    },
    sidebarRightList() {
      return this.$store.getters["orteundwege/sidebarRightList"];
    }
  }
};
</script>

<style lang="scss">
.ksm-orteundwege__accordion-container {
  @extend .ksm-hyphens;
  position: absolute;
  height: 100%;
  width: 100%;
  overflow: auto;
  padding: 10px;
  padding-bottom: 15em;

  table {
    td {
      padding-right: 5px;
    }
  }
}
.ksm-icon-circle {
  width: 16px;
  height: 16px;
  background: $lightGrey;
  border: 2px solid #fff;
  -moz-border-radius: 8px;
  -webkit-border-radius: 8px;
  border-radius: 8px;
}

.ksm-orteundwege__merzgebiete-icon {
  border: 1px solid $darkGrey;
  width: 0.8em;
  height: 0.8em;
  margin-right: 5px;
  cursor: pointer;
}

.ksm-orteundwege__accordion-row {
  // @extend .ksm-flex;
  cursor: pointer;
  vertical-align: text-top;

  &.__merzabende {
    &:hover {
      color: #f39400;
    }
  }
  &.__merzabende-active {
    color: #f39400;
  }

  &.__holland {
    &:hover {
      color: #b80718;
    }
  }
  &.__holland-active {
    color: #b80718;
  }

  &.__veranstaltung {
    &:hover {
      color: #009ee3;
    }
  }
  &.__veranstaltung-active {
    color: #009ee3;
  }

  &.__ausstellung {
    &:hover {
      color: #009037;
    }
  }
  &.__ausstellung-active {
    color: #009037;
  }

  &.__veröffentlichung {
    &:hover {
      color: #004594;
    }
  }
  &.__veröffentlichung-active {
    color: #004594;
  }

  &.__institutionen {
    &:hover {
      color: #94127d;
    }
  }
  &.__institutionen-active {
    color: #94127d;
  }
}
</style>


// WEBPACK FOOTER //
// Sidebar.OrteUndWege.vue?40d4bb41